<template>
  <div>
    <!-- breadcrumb area start -->
    <div class="breadcrumb-area">
<!--      <div class="container">-->
        <div class="row">
          <div class="col-md-12">
            <ol class="breadcrumb font-class">
              <li><a href="/#/home" v-on:click="sendMsg"><span class="fa fa-home"></span></a></li>
              <li><a href="/#/center" v-on:click="sendMsg">核心业务</a></li>
              <li><a href="/#/bridge" v-on:click="sendMsg">桥梁振动监测</a></li>
              <li class="active">地震或船撞监测</li>
            </ol>
          </div>
        </div>
<!--      </div>-->
    </div>
    <!-- breadcrumb area end -->

    <!-- contact information start -->
    <div class="contant-information pt-20">
<!--      <div class="container">-->
        <div class="row">
          <div class="center_column col-xs-12 col-sm-12">
            <div class="rte">
              <h1 style="text-align:center;font-size: 20px">地震或船撞监测</h1>
              <hr>
              <p class="titleP">地震或船撞监测的重要性</p>
              <p>在桥梁建设过程中，无法避免的存在施工质量问题。在投入使用后，各种荷载的反复作用，
                洪水、地震等自然因素破坏，都将给桥梁带来一定的损伤。所以对于桥梁的地震或船撞监测显得尤为重要。 </p>
              <p class="titleP">地震或船撞监测的特点</p>
              <p>振动监测具有无人值守、连续监测、实时传输、实时存储等特点；
                事故预警包括地震预警和撞击预警；因此，监测系统的预警准确率和人工智能化显得尤为重要。 </p>
              <p class="titleP">地震或船撞监测的设备</p>
              <p>传感器：BY-S07型振动传感器、991B型振动传感器。</p>

              <p>BY-S07型振动传感器、991B型振动传感器，两种传感器低频性能好，
                量程为±2g，分辨率达10-7g，适合在桥梁地震监测中使用，
                可以安装在桥墩或者桥的两端。BY-S07型振动传感器的防护等级达到IP67等级，
                991B型振动传感器防水需配防水密封盒。</p>

              <p>采集设备：BY-D2000A型工程强震仪、D3000型数据采集仪</p>

              <p>BY-D2000A型工程强震仪具有强震预警、烈度速算、邮件速报等功能，
                用户可以自行设定触发阈值，其中邮件速报功能需使工程强震仪联网。
                该强震仪有4,8,16通道三个版本，用户可以自行选择主机通道数和传感器的数量。</p>
              <p>D3000型数据采集仪有户外采集箱版本，防水性能好，
                灵活开放的数据协议加大了结构强震监测的便捷性，
                用户可根据项目需求自行编制强震监测软件。 </p>
              <p class="titleP">地震或船撞监测的流程图</p>
              <div style="width:80%;margin: 0 auto 50px">
                <img src="../../../assets/center/earthquake.png" alt="" style="width:100%;height:auto;">
              </div>
              <p class="titleP">地震或船撞监测的案例</p>
              <p>某大桥的船撞监测现场图</p>
              <div style="width:80%;margin: 0 auto 50px">
                <img src="../../../assets/center/e2.png" alt="" style="width:100%;height:auto;">
              </div>
<!--              <img src="../../../assets/center/e2.png" alt="">-->
            </div>
          </div>
        </div>
<!--      </div>-->
    </div>
    <!-- contact information end -->
  </div>
</template>

<script>
import {getContactDetail} from '../../../utils/api'

export default {
  name: 'contact',
  data () {
    return {
      contactData: {},
      formLeft: {
        input1: '',
        input2: '',
        input3: ''
      }
    }
  },
  mounted () {
    this.getContactDetail()
  },
  methods: {
    render (String) {
      let temp = ''
      for (let item of String.split('\n')) {
        temp += item + '<br>'
      }
      return temp
    },
    async getContactDetail () {
      let contactData01 = await getContactDetail()
      if (localStorage.getItem('Language') === 'zh') {
        this.contactData = {
          address: this.render(contactData01.address_zh),
          email: contactData01.email,
          phone: contactData01.phone,
          work_time: this.render(contactData01.work_time_zh)
        }
      } else {
        this.contactData = {
          address: this.render(contactData01.address_en),
          email: contactData01.email,
          phone: contactData01.phone,
          work_time: this.render(contactData01.work_time_en)
        }
      }
      // console.log(this.contactData)
    },
    sendMsg () {
      this.$emit('headCurrent', 0)
      window.sessionStorage.setItem('currentFirstIndex', 0)
    }
  }
}
</script>

<!-- 面包屑导航样式 -->
<style scoped>
  .breadcrumb>li+li:before {
    padding: 0 5px;
    color: #000;
    content: ">";
    font-weight: lighter;
  }

  .breadcrumb>li span{
    font-size: 16px;
  }
</style>

<!-- 内容样式 -->
<style scoped>
  .center_column{
    min-height: 400px;
  }

  .center_column p{
    font-size: 14px;
    line-height: 22px;
    margin: 0 0 9px;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    color: #000;
    position: relative;
    font-family: 宋体;
  }

  .titleP{
    padding-left: 10px!important;
    font-size: 16px;
    font-weight: bold;
    margin: 10px 0 10px!important;
    font-family: 宋体;
    text-indent: 0!important;
  }

  .titleP:before{
    position: absolute;
    left: -5px;
    top: 0;
    content: "\2726";
    font-size: 14px;
  }

  .rte {
    background: transparent none repeat scroll 0 0;
    text-indent: 26px;
  }

  .rte img{
    width: 100%;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
    color: #000;
  }

</style>



// WEBPACK FOOTER //
// src/components/center/bridge/bridge-earthquake.vue